import { render, staticRenderFns } from "./IQSuggestOverlayExitConfirmDialog.vue?vue&type=template&id=2accba13&scoped=true"
import script from "./IQSuggestOverlayExitConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./IQSuggestOverlayExitConfirmDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQSuggestOverlayExitConfirmDialog.vue?vue&type=style&index=0&id=2accba13&prod&scoped=true&lang=css"
import style1 from "./IQSuggestOverlayExitConfirmDialog.vue?vue&type=style&index=1&id=2accba13&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2accba13",
  null
  
)

export default component.exports